<template>
    <div id="echart-multibar" :style="{width: '100%', height: '280px'} "></div>   
</template>

<script>


export default({
   data(){
       return{
           barName:[],
           barData:[],
           barTitle:"",
       }
   },
   mounted(){
    this.initChart()
   },
   methods: {
       initData(barData,barTitle) {
           this.barData = barData;
           this.barTitle = barTitle;
           for (let i = 0; i < this.barData.length; i++) {
               this.barName[i] = this.barData[i].name;
           }
       },
       initChart() {  
           this.barChart = this.echarts.init(document.getElementById("echart-multibar"));
           var option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'shadow'
                }
            },
            legend: {

            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
            },
            yAxis: {
                type: 'category',
                data: ['Major depressive disorder', 'Bipolar disorder', 'Schizophrenia', 'Anxiety disorder']
            },
            series: [
                {
                    name: 'SNP',
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [1474, 2944, 3131, 169]
                },
                {
                    name: 'Gene',
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [1396, 6837, 11478, 795]
                },
                {
                    name: 'ncRNA',
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [369, 1058, 662, 35]
                },
                {
                    name: 'Methylation',
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [501, 0, 12098, 0]
                },
                {
                    name: 'Metabolite',
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [18039, 0, 0, 0]
                },
                {
                    name: 'Protein',
                    type: 'bar',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [19443, 0, 0, 0]
                }
            ]
            };
           this.barChart.setOption(option);
           //随着屏幕大小调节图表
           window.onresize = this.barChart.resize();
       }
   }
})
</script>
